@if (pformGroup) {
  <div class="flexgrid description" [formGroup]="pformGroup">
    <div class="gridChild flexrow">
      <div class="col25">
        @if (!canEditGeneral) {
          <span >Template&nbsp;&nbsp;#{{ pformGroup.value.id }}&nbsp;&nbsp;</span>
        }
      </div>
      <div class="col70">
        @if (canEditGeneral) {
          <input  class="smart-input" style="width: 100%;" type="text" formControlName="name">
        } @else {
          <!-- Spécifique d'un template : le nom est un lien vers la page d'édition du template (même rendu que le lien fabricant). -->
          <a class="smart-input template-link" [routerLink]="['/sales/product-tpl', pformGroup.value.id]"
            title="Ouvrir le template #{{ pformGroup.value.id }}">{{ pformGroup.value.name }}</a>
        }
      </div>
    </div>
    <div class="gridChild flexrow">
      <div class="col25">
        <div>Taux de TVA</div>
      </div>
      <div class="col70">
        <smart-select width="150px" [items]="vat" formControlName="vat" bindLabel="name" bindValue="id" (selectionChange)="tva_change($event)"></smart-select>
      </div>
    </div>
    <div class="gridChild flexrow">
      <div class="col25">
        <div>U. Vente Conso.</div>
      </div>
      <div class="col70">
        <smart-select width="17rem" [items]="salesUnit" formControlName="baseuom" bindLabel="name" bindValue="id"></smart-select>
      </div>
    </div>
    <div class="gridChild flexrow">
      <div class="col25">
        <div>U. Mesure</div>
      </div>
      <div class="col70">
        <smart-select width="17rem" [items]="salesUnit" formControlName="unitpriceuom" bindLabel="name" bindValue="id"></smart-select>
      </div>
    </div>
    <div class="gridChild flexrow manuf-row">
      <div class="col25">
        <div>Fabricant&nbsp;:&nbsp;&nbsp;</div>
      </div>
      <div class="col70">
        <app-search-partner [showSelectionInInput]="true" id="search-manuf"
          [canEdit]="canEditGeneral"
          [currentPartner]="$safeNavigationMigration(pformGroup.get('lnk_partner_manuf')?.value)"
          (partnerChange)="manufactureChange($event)"
          [roles]="[ROLE_MANUFACTURER]">
        </app-search-partner>
      </div>
    </div>
    <div class="gridChild flexrow">
      <!-- <div class="col25">
      <div>Mémo</div>
    </div> -->
    <div class="col95">
      @if (defaultMemoControl) {
        <mat-form-field appearance="outline" class="w-full" style="width: 100%;">
          <mat-label>Mémo</mat-label>
          <textarea matInput [formControl]="defaultMemoControl" rows="3"></textarea>
        </mat-form-field>
      }
    </div>
  </div>
  <div class="gridChild flexcolumn">
    <div class="arbo-row">
      <div class="col25">
        <button [disabled]="!canEditGeneral" type="button" class="custom-filled-button" (click)="openTreeDialog('princ')">
          <mat-icon class="" fontSet="material-symbols-outlined">graph_2</mat-icon>
          Principale
        </button>
      </div>
      <div class="col70">
        <div>
          @for (treeNode of selectedTreeNode; track treeNode) {
            <div class="selected-category">
              @if (treeNode.path && treeNode.path.split('.')[0] ==='princ') {
                <span>
                  {{ treeNode.path.split('.').slice(1).join(' > ') }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="arbo-row">
      <div class="col25">
        <button [disabled]="!canEditGeneral" type="button" class="custom-filled-button" (click)="openTreeDialog('config')">
          <mat-icon class="" fontSet="material-symbols-outlined">graph_2</mat-icon>
          Config
        </button>
      </div>
      <div class="col70">
        <div>
          @for (treeNode of selectedTreeNode; track treeNode) {
            <div class="selected-category">
              @if (treeNode.path && treeNode.path.split('.')[0] ==='config') {
                <span>
                  {{ treeNode.path.split('.').slice(1).join(' > ') }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <!-- Fournisseur -->
  <div class="gridChild flexrow">
    <div class="supplier-wrapper">
      <app-search-partner [canEdit]="canEditGeneral" width="300px" id="search-supplier" (partnerChange)="addSupplier($event)" [roles]="[ROLE_SUPPLIER]"> </app-search-partner>
      @for (supplier of pformGroup.value.lnk_suppliers; track supplier) {
        <div class="flexrow" style="align-items: center;">
          <button [disabled]="!canEditGeneral" type="button" class="custom-icon-button error" (click)="removeSupplier(supplier)">
            <mat-icon>delete</mat-icon>
          </button>
          <a mat-button (click)="openPartnerDialog(supplier.id)">{{ supplier.name }}</a>
        </div>
      }
    </div>
  </div>
  <div class="image-column">
    @if (defaultImage) {
      @if (defaultImage.thumbnailLocalUrl) {
        <img (click)="onImageClick()" [src]="defaultImage.thumbnailLocalUrl"
          [alt]="defaultImage.name || 'Image par défaut'" />
      }
    }
    @if (!defaultImage?.thumbnailLocalUrl) {
      <div class="no-image-placeholder">
        Aucune image par défaut
      </div>
    }
  </div>
</div>
}